<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- 品牌宣传区 -->
      <div class="footer-brand">
        <div class="brand-left">
          <h2 class="brand-title">宠物星系</h2>
          <p class="brand-desc">为每一只回到母星的毛孩子建立永恒档案，让爱永远延续。</p>
        </div>
        <div class="brand-right">
          <div class="social-platform-title">宠物星系全平台同名</div>
          <div class="social-links">
            <div class="social-item taobao-item">
              <span class="social-link">淘宝</span>
              <div class="taobao-popup">
                <div class="qr-item">
                  <img src="/tb.jpg" alt="淘宝店铺" class="qr-img">
                  <span>宠物星系淘宝店铺</span>
                </div>
              </div>
            </div>
            <div class="social-item xiaohongshu-item">
              <span class="social-link">小红书</span>
              <div class="xiaohongshu-popup">
                <div class="qr-item">
                  <img src="/xhs.jpg" alt="小红书" class="qr-img">
                  <span>宠物星系小红书</span>
                </div>
              </div>
            </div>
            <div class="social-item douyin-item">
              <span class="social-link">抖音</span>
              <div class="douyin-popup">
                <div class="qr-item">
                  <img src="/dy.jpg" alt="抖音" class="qr-img">
                  <span>宠物星系抖音号</span>
                </div>
              </div>
            </div>
            <div class="social-item xiaochengxu-item">
              <span class="social-link">小程序</span>
              <div class="xiaochengxu-popup">
                <div class="qr-item">
                  <img src="/logo.png" alt="小程序" class="qr-img">
                  <span>宠物星系小程序</span>
                </div>
              </div>
            </div>
            <div class="social-item wechat-item">
              <span class="social-link">公众号</span>
              <div class="wechat-popup">
                <div class="qr-item">
                  <img src="/gzh.jpg" alt="公众号" class="qr-img">
                  <span>宠物星系公众号</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 法律信息 -->
      <div class="footer-legal">
        <div class="beian-info">
          <p class="beian-line">
            <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" class="beian-link">
              粤ICP备2026038174号
            </a>
            <span class="beian-divider">|</span>
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602015579" target="_blank" rel="noopener noreferrer" class="beian-link beian-gongan">
              <img src="/police.png" alt="公安备案" class="beian-icon" onerror="this.style.display='none'">
              粤公网安备44010602015579号
            </a>
          </p>
        </div>
        <div class="legal-links">
          <router-link to="/privacy">隐私政策</router-link>
          <span class="link-divider">|</span>
          <router-link to="/legal">法律声明</router-link>
          <span class="link-divider">|</span>
          <router-link to="/brand#contact">联系我们</router-link>
        </div>
        <p class="copyright">&copy; 2026 广州爱匠文化有限公司 版权所有</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
/* 星空主题 Footer */
.footer {
  background: linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%);
  color: #fff;
  padding: 80px 0 30px;
  margin-top: auto;
  position: relative;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(circle at 80% 20%, rgba(123, 104, 238, 0.1) 0%, transparent 40%),
    radial-gradient(circle at 20% 80%, rgba(230, 168, 215, 0.08) 0%, transparent 40%);
  pointer-events: none;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

/* 品牌宣传区 */
.footer-brand {
  margin-bottom: 60px;
  display: flex;
  align-items: center;
  gap: 60px;
  padding-top: 160px;
  margin-top: -160px;
}

.brand-left {
  flex: 1;
}

.brand-title {
  font-size: 2.5rem;
  color: #fff;
  margin-bottom: 15px;
  font-weight: 700;
  text-shadow: 0 0 30px rgba(123, 104, 238, 0.5);
}

.brand-desc {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  margin-bottom: 0;
  max-width: 500px;
}

.brand-right {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.social-platform-title {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 5px;
}

/* 社交链接 */
.social-links {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
}

.social-item {
  position: relative;
  z-index: 1;
}

.social-item:hover {
  z-index: 9998;
}

.social-link {
  display: inline-block;
  padding: 12px 28px;
  background: rgba(123, 104, 238, 0.2);
  border-radius: 25px;
  font-size: 0.95rem;
  color: #fff;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 1px solid rgba(123, 104, 238, 0.3);
}

.social-link:hover {
  background: rgba(123, 104, 238, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(123, 104, 238, 0.3);
  border-color: rgba(123, 104, 238, 0.5);
}

/* 微信弹出层 */
.wechat-popup {
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: none;
  gap: 20px;
  margin-bottom: 15px;
  white-space: nowrap;
  z-index: 9999;
}

.wechat-item:hover .wechat-popup {
  display: flex;
}

.wechat-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 30px;
  border: 8px solid transparent;
  border-top-color: #fff;
}

/* 抖音弹出层 */
.douyin-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: none;
  gap: 20px;
  margin-bottom: 15px;
  white-space: nowrap;
  z-index: 9999;
}

.douyin-item:hover .douyin-popup {
  display: flex;
}

.douyin-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 8px solid transparent;
  border-top-color: #fff;
}

/* 淘宝弹出层 */
.taobao-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: none;
  gap: 20px;
  margin-bottom: 15px;
  white-space: nowrap;
  z-index: 9999;
}

.taobao-item:hover .taobao-popup {
  display: flex;
}

.taobao-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 8px solid transparent;
  border-top-color: #fff;
}

/* 小红书弹出层 */
.xiaohongshu-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: none;
  gap: 20px;
  margin-bottom: 15px;
  white-space: nowrap;
  z-index: 9999;
}

.xiaohongshu-item:hover .xiaohongshu-popup {
  display: flex;
}

.xiaohongshu-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 8px solid transparent;
  border-top-color: #fff;
}

/* 小程序弹出层 */
.xiaochengxu-popup {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  display: none;
  gap: 20px;
  margin-bottom: 15px;
  white-space: nowrap;
  z-index: 9999;
}

.xiaochengxu-item:hover .xiaochengxu-popup {
  display: flex;
}

.xiaochengxu-popup::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border: 8px solid transparent;
  border-top-color: #fff;
}

.qr-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.qr-img {
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 8px;
}

.qr-item span {
  color: #333;
  font-size: 0.85rem;
}

.mobile-item {
  cursor: help;
}

/* 法律信息 */
.footer-legal {
  border-top: 1px solid rgba(123, 104, 238, 0.2);
  padding-top: 30px;
  text-align: center;
}

.beian-info {
  margin-bottom: 20px;
}

.beian-line {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9rem;
}

.beian-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s ease;
}

.beian-link:hover {
  color: #9d7bff;
}

.beian-divider {
  color: rgba(123, 104, 238, 0.5);
}

.beian-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

.legal-links {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  flex-wrap: wrap;
}

.legal-links a {
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;
}

.legal-links a:hover {
  color: #9d7bff;
}

.link-divider {
  color: rgba(123, 104, 238, 0.5);
}

.copyright {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.85rem;
}

@media (max-width: 768px) {
  .footer {
    padding: 60px 0 25px;
  }

  .footer-brand {
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
  }

  .brand-title {
    font-size: 2rem;
  }

  .brand-desc {
    font-size: 1rem;
    margin-bottom: 20px;
  }

  .social-links {
    justify-content: flex-start;
  }

  .wechat-popup,
  .douyin-popup {
    left: 50%;
    transform: translateX(-50%);
  }

  .wechat-popup::after,
  .douyin-popup::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .beian-line {
    flex-direction: column;
    gap: 5px;
  }

  .beian-divider {
    display: none;
  }

  .legal-links {
    flex-direction: column;
    gap: 10px;
  }

  .link-divider {
    display: none;
  }
}
</style>
